import { createContext } from 'react'

import { NextFormContextType } from './types'

export const NextFormContext = createContext<NextFormContextType>({} as NextFormContextType)
